import React from 'react';
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import { useState } from 'react';
import Tutrial from './Tutrial';

import TutrialImage1_1 from "../asset/tutrial/ins/tutrial1.gif";
import TutrialImage1_2 from "../asset/tutrial/ins/tutrial2.jpg";
import TutrialImage2_1 from "../asset/tutrial/inh/tutrial1.gif";
import TutrialImage2_2 from "../asset/tutrial/inh/tutrial2.jpg";
import TutrialImage3_1 from "../asset/tutrial/dec/tutrial1.gif";
import TutrialImage3_2 from "../asset/tutrial/dec/tutrial2.jpg";
import TutrialImage4_1 from "../asset/tutrial/iry/tutrial1.gif";
import TutrialImage4_2 from "../asset/tutrial/iry/tutrial2.jpg";
import TutrialImage4_3 from "../asset/tutrial/iry/tutrial3.gif";
import TutrialImage4_4 from "../asset/tutrial/iry/tutrial4.gif";
import TutrialImage5_1 from "../asset/tutrial/ser1/tutrial1.gif";
import TutrialImage5_2 from "../asset/tutrial/ser1/tutrial2.jpg";
import TutrialImage6_1 from "../asset/tutrial/ser2/tutrial1.gif";
import TutrialImage6_2 from "../asset/tutrial/ser2/tutrial2.jpg";

const TutrialList = () => {
    const [tut1, displayTut1] = useState(false);
    const [tut2, displayTut2] = useState(false);
    const [tut3, displayTut3] = useState(false);
    const [tut4, displayTut4] = useState(false);
    const [tut5, displayTut5] = useState(false);
    const [tut6, displayTut6] = useState(false);
    const [open, setOpen] = useState(true);

    const closeTutrial1 = () => {
        displayTut1(false);
        setOpen(true);
    }
    const closeTutrial2 = () => {
        displayTut2(false);
        setOpen(true);
    }
    const closeTutrial3 = () => {
        displayTut3(false);
        setOpen(true);
    }
    const closeTutrial4 = () => {
        displayTut4(false);
        setOpen(true);
    }
    const closeTutrial5 = () => {
        displayTut5(false);
        setOpen(true);
    }
    const closeTutrial6 = () => {
        displayTut6(false);
        setOpen(true);
    }

    return (
        <div>
            {tut1 && <Tutrial closeTutrial={closeTutrial1} image1={TutrialImage1_1} image2={TutrialImage1_2} />}
            {tut2 && <Tutrial closeTutrial={closeTutrial2} image1={TutrialImage2_1} image2={TutrialImage2_2} />}
            {tut3 && <Tutrial closeTutrial={closeTutrial3} image1={TutrialImage3_1} image2={TutrialImage3_2} />}
            {tut4 && <Tutrial closeTutrial={closeTutrial4} image1={TutrialImage4_1} image2={TutrialImage4_2} image3={TutrialImage4_3} image4={TutrialImage4_4} />}
            {tut5 && <Tutrial closeTutrial={closeTutrial5} image1={TutrialImage5_1} image2={TutrialImage5_2} />}
            {tut6 && <Tutrial closeTutrial={closeTutrial6} image1={TutrialImage6_1} image2={TutrialImage6_2} />}
            {open &&
                <List>
                    <ListItem button onClick={() => { displayTut1(true); setOpen(false) }} divider>
                        <ListItemText>非課税枠の効果</ListItemText>
                    </ListItem>
                    <ListItem button onClick={() => { displayTut2(true); setOpen(false) }} divider>
                        <ListItemText>相続税計算・限界税率</ListItemText>
                    </ListItem>
                    <ListItem button onClick={() => { displayTut3(true); setOpen(false) }} divider>
                        <ListItemText>相続税の減少</ListItemText>
                    </ListItem>
                    <ListItem button onClick={() => { displayTut4(true); setOpen(false) }} divider>
                        <ListItemText>遺産分割シミュレーション</ListItemText>
                    </ListItem>
                    <ListItem button onClick={() => { displayTut5(true); setOpen(false) }} divider>
                        <ListItemText>退職金の手取計算</ListItemText>
                    </ListItem>
                    <ListItem button onClick={() => { displayTut6(true); setOpen(false) }} divider>
                        <ListItemText>退職金の支給可能目安</ListItemText>
                    </ListItem>
                    <ListItem>
                        <ListItemText> </ListItemText>
                    </ListItem>
                </List>}
        </div>
    );
}

export default TutrialList;